import { Controller } from "@hotwired/stimulus"
import * as React from "react"
import * as ReactDOM from "react-dom"
import { PaintbrushApp } from "../paintbrush/paintbrush_app"

export default class extends Controller {
  static values = {
    annotationId: Number,
    annotationName: String,
    teamId: Number,
    teamName: String,
    backButtonPath: String,
    geojsonUrl: String,
    projectDefraHedgerowPermission: Boolean,
    projectKewRgb25cmPermission: Boolean,
    projectKewSamplesPermission: Boolean,
    projectNatmapSoilPermission: Boolean,
    projectKewLidarPermission: Boolean,
    projectPlanetDataPermission: Boolean,
    projectUkEnabled: Boolean,
    projectIndonesiaEnabled: Boolean,
    userGuestStatus: Boolean,
    layerState: Object
  }

  declare readonly annotationIdValue: number
  declare readonly annotationNameValue: string
  declare readonly teamIdValue: number
  declare readonly teamNameValue: string
  declare readonly backButtonPathValue: string
  declare readonly geojsonUrlValue: string
  declare readonly projectDefraHedgerowPermissionValue: boolean
  declare readonly projectKewRgb25cmPermissionValue: boolean
  declare readonly projectKewSamplesPermissionValue: boolean
  declare readonly projectNatmapSoilPermissionValue: boolean
  declare readonly projectKewLidarPermissionValue: boolean
  declare readonly projectPlanetDataPermissionValue: boolean
  declare readonly projectUkEnabledValue: boolean
  declare readonly projectIndonesiaEnabledValue: boolean
  declare readonly userGuestStatusValue: boolean
  declare readonly layerStateValue: Record<string, unknown>

  connect() {
    ReactDOM.render(
      <PaintbrushApp
        annotationId={this.annotationIdValue}
        annotationName={this.annotationNameValue}
        teamId={this.teamIdValue}
        teamName={this.teamNameValue}
        backButtonPath={this.backButtonPathValue}
        geojsonUrl={this.geojsonUrlValue || undefined}
        permissions={{
          DefraHedgerows: this.projectDefraHedgerowPermissionValue,
          KewRgb25cm: this.projectKewRgb25cmPermissionValue,
          KewSamples: this.projectKewSamplesPermissionValue,
          NATMAPSoil: this.projectNatmapSoilPermissionValue,
          KewLidar: this.projectKewLidarPermissionValue,
          PlanetData: this.projectPlanetDataPermissionValue,
          isUserGuest: this.userGuestStatusValue,
          ukEnabled: this.projectUkEnabledValue,
          indonesiaEnabled: this.projectIndonesiaEnabledValue
        }}
        initialLayerState={this.layerStateValue || {}}
      />,
      this.element
    )
  }

  disconnect() {
    ReactDOM.unmountComponentAtNode(this.element)
  }
}

